import { render, staticRenderFns } from "./BottomA.vue?vue&type=template&id=72124271&scoped=true&"
import script from "./BottomA.vue?vue&type=script&lang=js&"
export * from "./BottomA.vue?vue&type=script&lang=js&"
import style0 from "./BottomA.vue?vue&type=style&index=0&id=72124271&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72124271",
  null
  
)

export default component.exports